export default {
    namespaced: true,
    state: {
        show: false,
        message: 'Loading',
        progressColor: 'primary',
        caller: ''
    },
    getters: {
    },
    mutations: {
        setShow( state, data ) {
            state.show = data;
        },
        setMessage( state, data ) {
            state.message = data;
        },
        setProgressColor( state, data ) {
            state.progressColor = data;
        },
        setCaller( state, data ) {
            state.caller = data;
        }
    },
    actions: {
        toggle( context, payload ) {
            context.commit( 'setShow', !context.state.show );
        },
        show( context, payload ) {
            // check if the payload is not null
            if ( payload !== null ) {
                // check for message
                if ( payload.hasOwnProperty( 'message' ) ) {
                    context.commit( 'setMessage', payload.message );
                }
                // check for progressColor
                if ( payload.hasOwnProperty( 'progressColor' ) ) {
                    context.commit( 'setProgressColor', payload.progressColor );
                }
                // check for caller
                if ( payload.hasOwnProperty( 'caller' ) ) {
                    context.commit( 'setCaller', payload.caller );
                }
            }
            context.commit( 'setShow', true );
        },
        hide( context, payload ) {
            // check if the payload is not null
            if ( payload !== null ) {
                // check for caller
                if ( payload.hasOwnProperty( 'caller' ) ) {
                    if ( payload.caller == context.state.caller ) {
                        context.commit( 'setShow', false );
                    }
                } else {
                    context.commit( 'setShow', false );
                }
            } else {
                context.commit( 'setShow', false );
            }
        }
    }
}